import { render, staticRenderFns } from "./AuthLoginAlert.vue?vue&type=template&id=37bbbfe0&scoped=true"
import script from "./AuthLoginAlert.vue?vue&type=script&lang=js"
export * from "./AuthLoginAlert.vue?vue&type=script&lang=js"
import style0 from "./AuthLoginAlert.vue?vue&type=style&index=0&id=37bbbfe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bbbfe0",
  null
  
)

export default component.exports